// Models
import { BaseModel } from '../../../woopa-ui/api';

/**
 * Represents a user in the app.
 */
export interface User extends BaseModel {
  email: any;
  name: string;
  role: string;
  mustBeNotified: boolean;
  // Optional
  createdAt?: string;
  isAdmin?: boolean;
}

/**
 * List of user role.
 */
export const USER_ROLES = [
  {
    value: 'admin',
    name: 'Administrador'
  },
  {
    value: 'supervisor',
    name: 'Supervisor'
  }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/user.interface.ts